import React, { useState } from 'react';
import {
    Box,
    Button,
    Container,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    TablePagination,
    // Chip,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
} from '@mui/material';
// import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
// import DownloadIcon from '@mui/icons-material/Download';
// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import VisibilityIcon from '@mui/icons-material/Visibility';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import TableChartIcon from '@mui/icons-material/TableChart';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

// ─── Mock Data ────────────────────────────────────────────────────────────────

const breakdownSummaryRows = [
    { id: 1, busNo: 'NB-2567', depot: 'Colombo Depot', totalTrips: 312, breakdownCount: 18, breakdownRate: '5.77%', totalDowntime: 36.45, avgDowntime: 2.02, lastBreakdown: '30/05/2026', affectedTrips: 21, severityIndex: 78, severity: 'High' },
    { id: 2, busNo: 'NB-1123', depot: 'Kandy Depot', totalTrips: 298, breakdownCount: 15, breakdownRate: '5.03%', totalDowntime: 28.30, avgDowntime: 1.89, lastBreakdown: '29/05/2026', affectedTrips: 17, severityIndex: 69, severity: 'High' },
    { id: 3, busNo: 'NB-3344', depot: 'Kurunegala Depot', totalTrips: 276, breakdownCount: 11, breakdownRate: '3.99%', totalDowntime: 17.20, avgDowntime: 1.56, lastBreakdown: '25/05/2026', affectedTrips: 12, severityIndex: 48, severity: 'Medium' },
    { id: 4, busNo: 'NB-2578', depot: 'Matara Depot', totalTrips: 290, breakdownCount: 9, breakdownRate: '3.10%', totalDowntime: 15.10, avgDowntime: 1.68, lastBreakdown: '27/05/2026', affectedTrips: 9, severityIndex: 41, severity: 'Medium' },
    { id: 5, busNo: 'NB-8891', depot: 'Galle Depot', totalTrips: 301, breakdownCount: 8, breakdownRate: '2.65%', totalDowntime: 12.60, avgDowntime: 1.58, lastBreakdown: '26/05/2026', affectedTrips: 8, severityIndex: 34, severity: 'Medium' },
    { id: 6, busNo: 'NB-9901', depot: 'Jaffna Depot', totalTrips: 287, breakdownCount: 6, breakdownRate: '2.09%', totalDowntime: 8.75, avgDowntime: 1.46, lastBreakdown: '20/05/2026', affectedTrips: 6, severityIndex: 27, severity: 'Low' },
    { id: 7, busNo: 'NB-6673', depot: 'Batticaloa Depot', totalTrips: 265, breakdownCount: 4, breakdownRate: '1.51%', totalDowntime: 6.10, avgDowntime: 1.53, lastBreakdown: '18/05/2026', affectedTrips: 4, severityIndex: 19, severity: 'Low' },
    { id: 8, busNo: 'NB-7782', depot: 'Anuradhapura Depot', totalTrips: 280, breakdownCount: 3, breakdownRate: '1.07%', totalDowntime: 4.55, avgDowntime: 1.52, lastBreakdown: '16/05/2026', affectedTrips: 3, severityIndex: 14, severity: 'Low' },
];

// const tripInspectionRows = [
//     { id: 1, inspectionTime: '30/05/2026 08:45', tripInstance: 'TRP-260530-001', routeCode: '001', direction: 'Colombo - Kandy', busNo: 'NB-2567', conductorId: 'EMP1025', passengerType: 'Adult', ticketRef: 'TKT-556677', boardingPoint: 'Colombo Fort', dropPoint: 'Kandy', fareExpected: 350.00, farePaid: 350.00, validationSource: 'POS Validation', status: 'Valid', issueType: '-', inspectorAction: 'No Action', remarks: '-' },
//     { id: 2, inspectionTime: '30/05/2026 09:10', tripInstance: 'TRP-260530-002', routeCode: '017', direction: 'Kandy - Kurunegala', busNo: 'NB-1123', conductorId: 'EMP1044', passengerType: 'Student', ticketRef: 'PASS-STU-88912', boardingPoint: 'Kandy', dropPoint: 'Kurunegala', fareExpected: 180.00, farePaid: 180.00, validationSource: 'Mobile App', status: 'Valid', issueType: '-', inspectorAction: 'No Action', remarks: 'Student Pass' },
//     { id: 3, inspectionTime: '30/05/2026 09:25', tripInstance: 'TRP-260530-003', routeCode: '025', direction: 'Kurunegala - Puttalam', busNo: 'NB-3344', conductorId: 'EMP1077', passengerType: 'Adult', ticketRef: '-', boardingPoint: 'Kurunegala', dropPoint: 'Puttalam', fareExpected: 240.00, farePaid: 0.00, validationSource: 'No Ticket', status: 'Invalid', issueType: 'No Ticket', inspectorAction: 'Issued Fine', remarks: 'Fine Rs. 500' },
//     { id: 4, inspectionTime: '30/05/2026 11:40', tripInstance: 'TRP-260530-004', routeCode: '027', direction: 'Puttalam - Chilaw', busNo: 'NB-2578', conductorId: 'EMP1090', passengerType: 'Child', ticketRef: 'TKT-778899', boardingPoint: 'Puttalam', dropPoint: 'Chilaw', fareExpected: 120.00, farePaid: 60.00, validationSource: 'POS Validation', status: 'Underpaid', issueType: 'Underpaid Fare', inspectorAction: 'Collected Fare', remarks: 'Collected Rs. 60' },
//     { id: 5, inspectionTime: '30/05/2026 12:05', tripInstance: 'TRP-260530-005', routeCode: '003', direction: 'Kandy - Matale', busNo: 'NB-9901', conductorId: 'EMP1025', passengerType: 'Senior Citizen', ticketRef: 'PASS-SEN-44556', boardingPoint: 'Kandy', dropPoint: 'Matale', fareExpected: 0.00, farePaid: 0.00, validationSource: 'Smart Card', status: 'Valid', issueType: '-', inspectorAction: 'No Action', remarks: 'Free Pass' },
//     { id: 6, inspectionTime: '30/05/2026 13:20', tripInstance: 'TRP-260530-006', routeCode: '019', direction: 'Matale - Dambulla', busNo: 'NB-6673', conductorId: 'EMP1033', passengerType: 'Adult', ticketRef: 'TKT-998877', boardingPoint: 'Matale', dropPoint: 'Dambulla', fareExpected: 150.00, farePaid: 150.00, validationSource: 'Counter Booking', status: 'Valid', issueType: '-', inspectorAction: 'No Action', remarks: '-' },
//     { id: 7, inspectionTime: '30/05/2026 15:15', tripInstance: 'TRP-260530-007', routeCode: '001', direction: 'Colombo - Kandy', busNo: 'NB-2567', conductorId: 'EMP1044', passengerType: 'Adult', ticketRef: 'TKT-445566', boardingPoint: 'Kadawatha', dropPoint: 'Kandy', fareExpected: 300.00, farePaid: 300.00, validationSource: 'POS Validation', status: 'Valid', issueType: '-', inspectorAction: 'No Action', remarks: '-' },
//     { id: 8, inspectionTime: '30/05/2026 16:00', tripInstance: 'TRP-260530-008', routeCode: '025', direction: 'Kurunegala - Puttalam', busNo: 'NB-3344', conductorId: 'EMP1077', passengerType: 'Adult', ticketRef: '-', boardingPoint: 'Kurunegala', dropPoint: 'Puttalam', fareExpected: 240.00, farePaid: 0.00, validationSource: 'No Ticket', status: 'Invalid', issueType: 'No Ticket', inspectorAction: 'Issued Fine', remarks: 'Fine Rs. 500' },
// ];

// ─── Status Chips ─────────────────────────────────────────────────────────────

const SeverityChip = ({ severity }) => {
    const map = { High: '#d32f2f', Medium: '#ed6c02', Low: '#2e7d32' };
    return (
        <Typography sx={{ color: map[severity] || '#999', fontWeight: 700, fontSize: 13 }}>
            {severity}
        </Typography>
    );
};

// const InspectionStatusChip = ({ status }) => {
//     const map = { Valid: '#2e7d32', Invalid: '#d32f2f', Underpaid: '#ed6c02' };
//     return (
//         <Chip
//             label={status}
//             size="small"
//             sx={{
//                 backgroundColor: map[status] || '#999',
//                 color: '#fff',
//                 fontWeight: 600,
//                 fontSize: 11,
//                 height: 22,
//                 borderRadius: '4px',
//                 minWidth: 65,
//             }}
//         />
//     );
// };

// ─── Pagination Hook ──────────────────────────────────────────────────────────

const usePagination = (defaultRows = 10) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(defaultRows);
    return {
        page, rowsPerPage,
        handleChangePage: (_, p) => setPage(p),
        handleChangeRowsPerPage: (e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); },
        startIndex: page * rowsPerPage,
    };
};

// ─── Component ────────────────────────────────────────────────────────────────

const BusBreakdownAnalysisPage = () => {

        const [depot, setDepot] = useState('');
        const [busNo, setBusNo] = useState('');
        
    // const [dateRange, setDateRange] = useState('01 May 2026 - 31 May 2026');

    const breakdownPag = usePagination();
    // const inspectionPag = usePagination();

    const thSx = { py: 1, fontWeight: 600, fontSize: 12 };
    const tdSx = { py: 0.5, fontSize: 12 };

    return (
        <Container component="main" maxWidth="full" sx={{ py: 0 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>

                {/* ── Page Title ── */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, mt: 3 }}>
                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                        Bus Breakdown Analysis
                    </Typography>
                </Box>

                {/* ══════════════════════════════════════════
                    TABLE 1 — Bus Breakdown Summary
                ══════════════════════════════════════════ */}

                {/* Sub-header */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 1 }}>
                    {/* <TableChartIcon sx={{ color: '#1976d2', fontSize: 20 }} /> */}
                     <Typography variant="h6" sx={{ fontWeight: 700 }}>Bus Breakdown Summary</Typography>
                    {/* <InfoOutlinedIcon sx={{ fontSize: 16, color: '#aaa', ml: 0.5 }} /> */}
                </Box>

  <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                        gap: 1.5,
                        width: '100%',
                        mb: 2,
                        mt: 1,
                        alignItems: 'center',
                    }}
                >
            
           
                    <FormControl size="small" fullWidth>
                        <InputLabel>Depot</InputLabel>
                        <Select value={depot} onChange={e => setDepot(e.target.value)} label="Depot">
                            <MenuItem value="">All Depots</MenuItem>
                            <MenuItem value="GAL">Galle (GAL)</MenuItem>
                            <MenuItem value="KND">Kandy (KND)</MenuItem>
                            <MenuItem value="MRT">Maradana (MRT)</MenuItem>
                            <MenuItem value="NWP">Nawinna (NWP)</MenuItem>
                            <MenuItem value="KUR">Kallyapitiya (KUR)</MenuItem>
                        </Select>
                    </FormControl>
   
                    <TextField
                        fullWidth size="small" label="Bus No."
                        value={busNo} onChange={e => setBusNo(e.target.value)}
                        placeholder="Select Bus"
                    />
                </Box>


                <Paper variant="outlined" sx={{ width: '100%', borderRadius: 2, mb: 4 }}>


                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                    <TableCell sx={thSx}>Bus No.</TableCell>
                                    <TableCell sx={thSx}>Owning Depot</TableCell>
                                    <TableCell sx={{ ...thSx, textAlign: 'center' }}>Total<br />Trips</TableCell>
                                    <TableCell sx={{ ...thSx, textAlign: 'center' }}>Breakdown<br />Count</TableCell>
                                    <TableCell sx={{ ...thSx, textAlign: 'center' }}>Breakdown<br />Rate %</TableCell>
                                    <TableCell sx={{ ...thSx, textAlign: 'center' }}>Total Downtime<br />(Hours)</TableCell>
                                    <TableCell sx={{ ...thSx, textAlign: 'center' }}>Avg Downtime<br />per Incident</TableCell>
                                    <TableCell sx={{ ...thSx, textAlign: 'center' }}>Last<br />Breakdown Date</TableCell>
                                    <TableCell sx={{ ...thSx, textAlign: 'center' }}>Affected<br />Trips</TableCell>
                                    <TableCell sx={{ ...thSx, textAlign: 'center' }}>Severity<br />Index</TableCell>
                                    <TableCell sx={thSx}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {breakdownSummaryRows
                                    .slice(breakdownPag.startIndex, breakdownPag.startIndex + breakdownPag.rowsPerPage)
                                    .map((row) => (
                                        <TableRow key={row.id} hover>
                                            <TableCell sx={tdSx}>
                                                <Typography variant="body2" sx={{ color: '#1976d2', cursor: 'pointer', fontWeight: 600, fontSize: 12, '&:hover': { textDecoration: 'underline' } }}>
                                                    {row.busNo}
                                                </Typography>
                                            </TableCell>
                                            <TableCell sx={tdSx}>{row.depot}</TableCell>
                                            <TableCell sx={{ ...tdSx, textAlign: 'center' }}>{row.totalTrips}</TableCell>
                                            <TableCell sx={{ ...tdSx, textAlign: 'center' }}>{row.breakdownCount}</TableCell>
                                            <TableCell sx={{ ...tdSx, textAlign: 'center' }}>{row.breakdownRate}</TableCell>
                                            <TableCell sx={{ ...tdSx, textAlign: 'center' }}>{row.totalDowntime}</TableCell>
                                            <TableCell sx={{ ...tdSx, textAlign: 'center' }}>{row.avgDowntime}</TableCell>
                                            <TableCell sx={{ ...tdSx, textAlign: 'center' }}>{row.lastBreakdown}</TableCell>
                                            <TableCell sx={{ ...tdSx, textAlign: 'center' }}>{row.affectedTrips}</TableCell>
                                            <TableCell sx={{ ...tdSx, textAlign: 'center' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                                                    {row.severityIndex}
                                                    <SeverityChip severity={row.severity} />
                                                </Box>
                                            </TableCell>
                                            <TableCell sx={tdSx}>
                                                {row.severity === 'High' ? (
                                                    <IconButton size="small" sx={{ color: '#1976d2', border: '1px solid #1976d2', borderRadius: '4px', p: 0.5 }}>
                                                        <VisibilityIcon sx={{ fontSize: 16 }} />
                                                    </IconButton>
                                                ) : (
                                                    <Button
                                                        size="small"
                                                        sx={{ minWidth: 0, p: '2px 6px', borderRadius: '4px', border: '1px solid #ccc', color: '#555', textTransform: 'none', fontSize: 18, lineHeight: 1 }}
                                                    >
                                                        •••
                                                    </Button>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        showFirstButton showLastButton
                        component="div"
                        count={breakdownSummaryRows.length}
                        page={breakdownPag.page}
                        onPageChange={breakdownPag.handleChangePage}
                        rowsPerPage={breakdownPag.rowsPerPage}
                        onRowsPerPageChange={breakdownPag.handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </Paper>

                {/* ══════════════════════════════════════════
                    TABLE 2 — Trip Inspection Register
                ══════════════════════════════════════════ */}

                {/* Section header row with title + date range + filters + export */}
                {/* <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2, flexWrap: 'wrap', gap: 2 }}>
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>Trip Inspection Register</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: 12, mt: 0.3 }}>
                            Monitor ticket checking and verification activities across trips.
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                        <Button
                            variant="outlined"
                            startIcon={<CalendarMonthIcon sx={{ fontSize: 16 }} />}
                            endIcon={<KeyboardArrowDownIcon sx={{ fontSize: 16 }} />}
                            size="small"
                            sx={{ textTransform: 'none', fontWeight: 500, borderRadius: '4px', height: '36px', fontSize: 13, color: '#333', borderColor: '#ccc' }}
                        >
                            01 May 2026 – 31 May 2026
                        </Button>
                        <Button
                            variant="outlined"
                            startIcon={<FilterListIcon sx={{ fontSize: 16 }} />}
                            size="small"
                            sx={{ textTransform: 'none', fontWeight: 500, borderRadius: '4px', height: '36px', fontSize: 13, color: '#333', borderColor: '#ccc' }}
                        >
                            Filters
                        </Button>
                        <Button
                            variant="outlined"
                            startIcon={<DownloadIcon sx={{ fontSize: 16 }} />}
                            endIcon={<KeyboardArrowDownIcon sx={{ fontSize: 16 }} />}
                            size="small"
                            sx={{ textTransform: 'none', fontWeight: 500, borderRadius: '4px', height: '36px', fontSize: 13, color: '#333', borderColor: '#ccc' }}
                        >
                            Export
                        </Button>
                    </Box>
                </Box>

                <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                <TableCell sx={thSx}>Inspection Time</TableCell>
                                <TableCell sx={thSx}>Trip Instance No.</TableCell>
                                <TableCell sx={thSx}>Route Code</TableCell>
                                <TableCell sx={thSx}>Direction</TableCell>
                                <TableCell sx={thSx}>Bus No.</TableCell>
                                <TableCell sx={thSx}>Conductor ID</TableCell>
                                <TableCell sx={thSx}>Passenger<br />Type</TableCell>
                                <TableCell sx={thSx}>Ticket / Pass<br />Ref No.</TableCell>
                                <TableCell sx={thSx}>Boarding Point</TableCell>
                                <TableCell sx={thSx}>Drop Point</TableCell>
                                <TableCell sx={{ ...thSx, textAlign: 'right' }}>Fare Expected<br />(Rs.)</TableCell>
                                <TableCell sx={{ ...thSx, textAlign: 'right' }}>Fare Paid /<br />Validated (Rs.)</TableCell>
                                <TableCell sx={thSx}>Validation<br />Source</TableCell>
                                <TableCell sx={thSx}>Status</TableCell>
                                <TableCell sx={thSx}>Issue Type</TableCell>
                                <TableCell sx={thSx}>Inspector<br />Action</TableCell>
                                <TableCell sx={thSx}>Remarks</TableCell>
                                <TableCell sx={thSx}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tripInspectionRows
                                .slice(inspectionPag.startIndex, inspectionPag.startIndex + inspectionPag.rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.id} hover>
                                        <TableCell sx={tdSx}>{row.inspectionTime}</TableCell>
                                        <TableCell sx={tdSx}>
                                            <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 600, fontSize: 12, cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>
                                                {row.tripInstance}
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={tdSx}>{row.routeCode}</TableCell>
                                        <TableCell sx={tdSx}>{row.direction}</TableCell>
                                        <TableCell sx={{ ...tdSx, fontWeight: 600 }}>{row.busNo}</TableCell>
                                        <TableCell sx={tdSx}>{row.conductorId}</TableCell>
                                        <TableCell sx={tdSx}>{row.passengerType}</TableCell>
                                        <TableCell sx={tdSx}>{row.ticketRef}</TableCell>
                                        <TableCell sx={tdSx}>{row.boardingPoint}</TableCell>
                                        <TableCell sx={tdSx}>{row.dropPoint}</TableCell>
                                        <TableCell sx={{ ...tdSx, textAlign: 'right' }}>{row.fareExpected.toFixed(2)}</TableCell>
                                        <TableCell sx={{ ...tdSx, textAlign: 'right' }}>{row.farePaid.toFixed(2)}</TableCell>
                                        <TableCell sx={tdSx}>{row.validationSource}</TableCell>
                                        <TableCell sx={tdSx}><InspectionStatusChip status={row.status} /></TableCell>
                                        <TableCell sx={tdSx}>{row.issueType}</TableCell>
                                        <TableCell sx={tdSx}>{row.inspectorAction}</TableCell>
                                        <TableCell sx={tdSx}>{row.remarks}</TableCell>
                                        <TableCell sx={tdSx}>
                                            <IconButton size="small" sx={{ color: '#1976d2', p: 0.5 }}>
                                                <VisibilityIcon sx={{ fontSize: 16 }} />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        showFirstButton showLastButton
                        component="div"
                        count={tripInspectionRows.length}
                        page={inspectionPag.page}
                        onPageChange={inspectionPag.handleChangePage}
                        rowsPerPage={inspectionPag.rowsPerPage}
                        onRowsPerPageChange={inspectionPag.handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </TableContainer> */}
                

            </Box>
        </Container>
    );
};

export default BusBreakdownAnalysisPage;